import React from 'react';
import { Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const CenteredTypography = styled(Typography).withConfig({
  componentId: "sc-3cl31l-0"
})(["&&&{text-align:center;}"]);
export default function TransferDescription(_ref) {
  let {
    data
  } = _ref;
  const description = data.getTransferDescription();
  const datePrefix = data.getDatePrefix();
  const date = data.getTransferDate();
  if (!datePrefix) {
    return /*#__PURE__*/React.createElement(CenteredTypography, {
      variant: "body2"
    }, description, " - ", date);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenteredTypography, {
    variant: "body2",
    "data-sentry-element": "CenteredTypography",
    "data-sentry-source-file": "TransferDescription.tsx"
  }, description), /*#__PURE__*/React.createElement(CenteredTypography, {
    variant: "body2",
    "data-sentry-element": "CenteredTypography",
    "data-sentry-source-file": "TransferDescription.tsx"
  }, datePrefix, " ", date));
}